import React from 'react';
import { StyleSheet, View, Text, Pressable, Image } from 'react-native';
import Collapsible from 'react-native-collapsible';

type Props = {
  isCollapsed?: boolean;
  setCollapsed: () => void;
  children: any;
  title: string;
};

const arrow = require('assets/dropdown.svg');

export function Dropdown({
  isCollapsed = false,
  setCollapsed,
  children,
  title,
}: Props) {
  return (
    <View style={styles.collapsible}>
      <Pressable
        style={styles.collapsibleButton}
        onPress={() => setCollapsed()}
      >
        <Text style={styles.collapsibleButtonText}>{title}</Text>
        <Image
          source={arrow}
          style={[styles.dropDownArrow, isCollapsed ? styles.flipped : null]}
        />
      </Pressable>
      <Collapsible collapsed={isCollapsed} style={styles.collapsibleContainer}>
        {children}
      </Collapsible>
    </View>
  );
}

const styles = StyleSheet.create({
  flipped: {
    transform: 'rotate(180deg)',
  },
  collapsible: {
    marginBottom: 10,
  },
  collapsibleButton: {
    backgroundColor: '#152B61',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 5,
  },
  collapsibleButtonText: {
    fontSize: 18,
    color: '#fff',
    fontWeight: 'bold',
    padding: 10,
  },
  collapsibleContainer: {
    borderWidth: 1,
    borderColor: '#152B61',
  },
  dropDownArrow: {
    width: 40,
    height: 40,
  },
});
